import { useEffect, useState } from 'react';

// Gestion des changements d'état du header sticky
const useStickyHeader = (
  stickyHeaderBounding: DOMRect | undefined,
  topElementBounding: DOMRect | undefined,
  containerElementBounding: DOMRect | undefined
) => {
  const tolerance = 0.5;

  const [isSticky, setIsSticky] = useState(false);

  // Translation Y du header "sticky"
  const [stickyTranslationY, setStickyTranslationY] = useState(0);

  // Met à jour le comportement "sticky" en fonction des positions actuelles
  useEffect(() => {
    // pour activer l'effet il faut que le composant contenant soit plus grand que le header sticky
    if (
      stickyHeaderBounding &&
      containerElementBounding &&
      topElementBounding &&
      stickyHeaderBounding.height < containerElementBounding.height
    ) {
      // Arrondi au dizième les valeurs de positions: necessaire pour éviter les effets de bords
      const stickyHeaderTop = stickyHeaderBounding.top;
      const stickyHeaderBottom = stickyHeaderBounding.bottom;
      const containerTop = containerElementBounding.top;
      const containerBottom = containerElementBounding.bottom;
      const topElementBottom = topElementBounding.bottom;

      if (stickyHeaderBottom >= containerBottom - tolerance) {
        if (stickyHeaderTop > topElementBottom + tolerance) {
          // lorsque le header est bloqué en bas du conteneur, lors du scroll vers le haut, réactivation du mode sticky
          setIsSticky(true);
          setStickyTranslationY(topElementBottom);
        } else {
          // dépassement du conteuneur, désactivation du sticky et le header reste bloqué en bas du conteneur
          setIsSticky(false);
          setStickyTranslationY(containerElementBounding.height - stickyHeaderBounding.height);
        }
      } else if (topElementBottom >= stickyHeaderTop - tolerance && stickyHeaderTop >= containerTop - tolerance) {
        // activation sticky lors du scroll vers le bas
        setIsSticky(true);
        setStickyTranslationY(topElementBottom);
      } else {
        // désactivation du sticky
        setIsSticky(false);
        setStickyTranslationY(0);
      }
    }
  }, [stickyHeaderBounding, topElementBounding, containerElementBounding]);

  return { isSticky, stickyTranslationY };
};

export default useStickyHeader;
